import { Space } from 'antd';
import { FC } from 'react';

import { Header } from '../components/Header';
import { LastAccessedPages } from '../components/LastAccessedPages';
import { useLastAccessedPages } from '../hooks/useLastAccessedPages';

export const HomeScreen: FC = () => {
  const lastAccdPages = useLastAccessedPages();

  return (
    <>
      <Space direction='vertical' size={24} style={{ width: '100%' }}>
        <Header />
        {lastAccdPages && <LastAccessedPages items={lastAccdPages} />}
      </Space>
    </>
  );
};
